// removed by extract-text-webpack-plugin
module.exports = {"reference":"_308OpDdR3D8LmP2Ch-7Ots","datasource":"_2owa7LbVLhW9kAfe2nHAD5","submit":"_25v9J8TvA3hJnBUFSygkID","published":"_2kmm_TOqB5kWi3ZqT9IBFl"};


//////////////////
// WEBPACK FOOTER
// ./src/views/wizard/reference/reference-edit/style.css
// module id = 236
// module chunks = 0